


What is your T-Shirt size? (Occasionally the winner/runner-up will recieve a shirt)
<br />
<select [(ngModel)]="shirtSize">
  <option value="Small">Small</option>
  <option value="Medium">Medium</option>
  <option value="Large">Large</option>
  <option value="X-Large">XL</option>
  <option value="XX-Large">XXL</option>
</select>
&nbsp;&nbsp;&nbsp;
<button (click)="submitShirt($event)">Save</button>

<br /><br />
<hr />
<br />

Select (or take) any photo to use as your avatar. Use the handles to crop it. Save it.
<br />
<input type="file" (change)="fileChangeEvent($event)" />
<image-cropper 
               [imageChangedEvent]="imageChangedEvent"
               [maintainAspectRatio]="true"
               [aspectRatio]="1 / 1"
               resizeToWidth=200
               resizeToHeight=200
               format="png"
               output="base64"
               (imageCropped)="imageCropped($event)"
               (imageLoaded)="imageLoaded($event)"
               (cropperReady)="cropperReady()"
               (loadImageFailed)="loadImageFailed()"></image-cropper>

               <br /><br />
<img *ngIf="croppedImage" [src]="croppedImage" style="border-radius: 50%; border: 3px solid black;" /> <!-- hide if no image yet -->
&nbsp;&nbsp;&nbsp;&nbsp;
<button [disabled]="croppedImage == null" (click)="submit($event)">Save My Photo</button> <!-- disable if no image picked -->
